import { STATUS_CODE } from '@kc-console/core';

import Error401Modal from './Error401Modal';

import type { ModalComponentProps } from '@kc-console/context';
import type { StatusCode } from '@kc-console/core';

export type ErrorModalProps = ModalComponentProps & {
  status: StatusCode;
};

/**
 * 에러 상태에 따라 적절한 에러 모달을 렌더링하는 컴포넌트
 * @description
 * - status 코드에 따라 다른 에러 모달을 표시합니다.
 * - 현재는 401 에러만 처리하며, 추후 다른 에러 타입 추가 가능합니다.
 * @example
 * <ErrorModal status={401} />
 */
const ErrorModal = (props: ErrorModalProps) => {
  const { status } = props;

  if (status === STATUS_CODE.UNAUTHORIZED_EXPIRED_TOKEN) return <Error401Modal />;
  return <></>;
};

export default ErrorModal;
